import { CompanyActionTypes, CompanyActions } from './company.actions';
import { ICompany } from '../../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: ICompany | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: CompanyActions): State {
    switch (action.type) {

        case CompanyActionTypes.LoadCompanyState: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case CompanyActionTypes.LoadCompanyStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case CompanyActionTypes.LoadCompanyStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case CompanyActionTypes.CompanyScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;